<template>
    <h1 class="tag-page__title">{{ title }}</h1>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {useTranslation} from '#imports';

    const {t} = useTranslation();

    const props = defineProps<{tag: string}>();

    const title = computed(() => t('landing.acquisition.main.title.short', [props.tag]));
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .tag-page__title {
        font-family: var(--joy-font-family-title);
        font-weight: var(--joy-font-weight-normal);
        line-height: var(--joy-line-height-small);
        margin-bottom: var(--joy-core-spacing-6);
        font-size: var(--joy-font-size-secondary-400);

        @include mq.screen_md(min) {
            font-size: var(--joy-font-size-secondary-800);
        }
    }
</style>
